const ABSOLUTE_HTTP_URL = /^https?:\/\//i;

export const INSTALL_FALLBACK_HASH = "#top";
export const PRICING_HASH = "#pricing";
export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/mindrail/peloooljfhlnpjpainmkpnimhokihlim";

const chromeStoreUrl =
  process.env.REACT_APP_CHROME_STORE_URL ||
  process.env.REACT_APP_CHROME_WEB_STORE_URL ||
  CHROME_STORE_URL;
const proCheckoutUrl = process.env.REACT_APP_PRO_CHECKOUT_URL || "";

export const hasChromeStoreUrl = ABSOLUTE_HTTP_URL.test(chromeStoreUrl);
export const hasProCheckoutUrl = ABSOLUTE_HTTP_URL.test(proCheckoutUrl);

export const installCta = {
  label: "Add to Chrome - free",
  shortLabel: "Install free",
  href: hasChromeStoreUrl ? chromeStoreUrl : INSTALL_FALLBACK_HASH,
  external: hasChromeStoreUrl,
};

export const pricingCta = {
  label: "See Pro features",
  shortLabel: "View Pro features",
  href: PRICING_HASH,
  external: false,
};

export const proCta = {
  label: hasProCheckoutUrl ? "Start Pro" : "Start Pro after install",
  href: hasProCheckoutUrl ? proCheckoutUrl : INSTALL_FALLBACK_HASH,
  external: hasProCheckoutUrl,
  configured: hasProCheckoutUrl,
};

export function externalLinkProps(isExternal) {
  return isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {};
}
